<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-20">
                        <h6 class="float-left mb-0 ml-10 fs-18 fw-700" style="color: #000000">{{orderType == 'BUY' ? 'Buy' : 'Claim' }} International eSIM</h6>
                    </div> 
                </div>
                <div class="col-md-12 text-start fs-16" style="color: black; font-weight: 600;">
                    <p>Select or Search your country to view eSIM plans</p>  
                </div>

                <div class="col-12 col-md-3 mb-20">
                    <div class="input-group country-search">
                        <span>
                          <i class="fa fa-map-marker" aria-hidden="true"></i>
                        </span>
                        <input type="text" class="form-control" placeholder="Search for Country" [(ngModel)]="searchCountryName" (input)="searchForCountry($event.target.value)" />
                        <i class="fa fa-times position-absolute" *ngIf="isCountrySelected"  style="right: 10px;cursor: pointer;z-index: 100;" (click)="clearCountrySelection()"></i>
                    </div>
                </div>

                <div class="esim-country-container">
                    <div class="row mt-6 custom-grid" *ngIf="!showDropdown">
                        <div class="country-section" *ngFor="let singleItem of filteredCountry | slice:0:displayCount">
                            <div class="d-flex flex-column align-items-center" (click)="onImageClick(singleItem)">
                                <img src="assets/images/buy-esim/{{singleItem.icon}}">
                                <div class="fs-14 fw-600 country-name text-center">
                                    {{ singleItem.title }}
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div class="container-fluid mt-2">
                      <div class="row">
                          
                          <div class="col-md-6">
                              <div class="country-section" *ngIf="showDropdown">
                                <div class="selected-country-container">
                                    <img src="assets/images/buy-esim/{{selectedCountryIcon}}" class="selected-country-img">
                                  </div>
                                  
                                  <div class="fs-14 fw-600 country-name1">
                                      {{ selectedCountry.title }}
                                  </div>
                  
                                  <section class="pb-15" *ngIf="!isDurationSelected">
                                      <div class="row">
                                          <div class="form-group col-md-6">
                                              <label class="form-label fw-600 fs-14" for="duration" style="color: black; text-align: left;">Trip Duration</label>
                                              <ng-select name="durationOptions"
                                                         [items]="durationOptions"
                                                         bindLabel="title"
                                                         bindValue="value"
                                                         [(ngModel)]="selectedDuration"
                                                         [clearable]="false"
                                                         [searchable]="true"
                                                         class="fs-14"
                                                         placeholder="Select Duration"
                                                         (change)="onDurationSelect()">
                                              </ng-select>
                                          </div>
                                      </div>
                                  </section>
                  
                                  <div class="mb-0 text-start" *ngIf="isDurationSelected" style="color: black; font-weight: 600;">
                                      <p class="fw-600 fs-14">Trip Duration</p>
                                      <div class="buy-card mt-20 col-md-6">
                                          <div class="buy-card-header trip-info row fw-500">  
                                              <span class="days">Number of Days</span>
                                              <span clsss=""></span>
                                              <span>{{ selectedDuration }} Days</span>
                                          </div>
                                      </div>
                  
                                      <div class="col-md-10 fw-500 fs-12 mt-10 lightning-icon row">
                                          <img src="assets/images/buy-esim/Lightning.png">
                                          <p>Activation valid when you land in destination</p>
                                      </div>
                  
                                      <p class="fw-600 fs-14">Features</p>
                                      <div class="buy-card mt-20 col-md-8">
                                          <div class="buy-card-header row fw-500">  
                                              <div class="features-image days">
                                                  <img src="assets/images/buy-esim/esim.png">
                                                  <p>eSIM</p>
                                              </div>
                                              <div class="features-image days">
                                                  <img src="assets/images/buy-esim/4g.png">
                                                  <p>4G/5G</p>
                                              </div>
                                              <div class="features-image days">
                                                  <img src="assets/images/buy-esim/data.png">
                                                  <p>Data Only</p>
                                              </div>
                                              <div class="features-image">
                                                  <img src="assets/images/buy-esim/noEkyc.png">
                                                  <p>No eKYC</p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                  

                              </div>
                          </div>
                  
                          
                          <div class="col-md-5 ms-auto plan-container"> 
                            <div class="d-flex flex-column" *ngIf="isDurationSelected && eSimPackeges.length > 0">
                                <div class="col-md-12 text-start fs-16" style="color: black; font-weight: 600;">
                                    <p>Select your Plan</p>  
                                </div>
                                

                                
                                <div class="plan-card mb-0 d-flex align-items-center justify-content-between w-100" *ngFor="let singlePackage of eSimPackeges">
                                    <div class="d-flex align-items-center">
                                        <input type="radio" name="plan" value="{{singlePackage.package_id}}" [(ngModel)]="selectedPlan" class="custom-radio me-2">
                                        <div class="d-flex flex-column text-left plan-card1">
                                            <h5>{{ singlePackage.package_name }}</h5>
                                            <p class="">{{ singlePackage.network != '' ? 'Network: '+singlePackage.network : '' }}</p>
                                            <p class="" *ngIf="singlePackage?.fup_policy != null">FUP limits applicable 
                                                <button rippleEffect class="tooltip-icon " placement="bottom" ngbTooltip="{{ singlePackage?.fup_policy }}">
                                                    <span [data-feather]=" 'info' " class=" 'ml-1' "></span>
                                                </button>
                                                
                                                <!-- <i class="fa fa-info-circle" data-toggle="tooltip" data-placement="bottom" data-custom-class="fup-tooltip" title="{{ singlePackage?.fup_policy }}"></i> -->
                                            </p>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <p class="price mb-0"><s>₹ {{ singlePackage.base_price }}</s> <strong class="fs-15">₹ {{ singlePackage.price }}</strong></p>
                                    </div>
                                </div>
                                <br />
                          
                                <!-- <div class="plan-card mb-0 d-flex align-items-center justify-content-between w-100">
                                    <div class="d-flex align-items-center">
                                        <input type="radio" name="plan" class="custom-radio me-2">
                                        <div class="d-flex flex-column text-left plan-card1">
                                            <h5>2 GB</h5>
                                            <p>T Mobile | Valid for 3 days</p>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <p class="price mb-0"><s>₹1000</s> <strong class="fs-15">₹800</strong></p>
                                    </div>
                                    
                                </div>
                          
                                <div class="plan-card mb-0 d-flex align-items-center justify-content-between w-100">
                                    <div class="d-flex align-items-center">
                                        <input type="radio" name="plan" class="me-2 custom-radio ">
                                        <div class="d-flex flex-column text-left plan-card1">
                                            <h5>5 GB</h5>
                                            <p>T Mobile | Valid for 3 days</p>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <p class="price mb-0"><s>₹1200</s> <strong class="fs-15">₹1000</strong></p>
                                    </div>
                                 
                                </div>

                                <div class="plan-card mb-20 d-flex align-items-center justify-content-between w-100">
                                    <div class="d-flex align-items-center">
                                        <input type="radio" name="plan" class="me-2 custom-radio ">
                                        <div class="d-flex flex-column text-left plan-card1">
                                            <h5>Unlimited</h5>
                                            <p>T Mobile | Valid for 3 days</p>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <p class="price mb-0"><s>₹1500</s> <strong class="fs-15">₹1200</strong></p>
                                    </div>
                                    
                                </div> -->
                                <div class="d-flex align-items-center">
                                    <img src="assets/images/buy-esim/vector.png" style="width: 20px;">
                                    <p class="fs-12 mb-0 fw-500">
                                        Check if your phone is <span style="text-decoration: underline;color: #1D2A62; cursor: pointer;"  (click)="opendevicesModal()">eSIM compatible</span>
                                    </p>
                                    </div>
                            </div>
                            <div class="d-flex" *ngIf="isDurationSelected && eSimPackeges.length == 0">
                                <p><Strong>No Plans Found for this country</Strong></p>
                            </div>

                          </div>
                          
                          

  </div>
</div>

                   
                  
                   
                    <div class="text-center mt-3" *ngIf="filteredCountry.length > 14 && !showDropdown">
                        <button class="btn btn-buy" (click)="toggleView()" *ngIf="displayCount === 14">View all countries</button>
                        <button class="btn btn-buy" (click)="toggleView()" *ngIf="displayCount !== 14">View less</button>
                    </div>
                                  
                    <div class="row m-0 p-0 mt-5" *ngIf="isCountrySelected">
                        <div class="col-6 text-left">
                            <button class="btn btn-buy" (click)="resetView()">Back</button>
                        </div>
                        <div class="col-6 text-right">
                            <button type="submit" rippleEffect class="btn btn-primary fs-12" (click)="goToESimForm()" >Proceed</button>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    </div>
</div>   

<ng-template #devicesModal let-modal>
    <div class="d-flex flex-column w-100 h-100">
        <div class="flex-grow-1 d-flex flex-column">
            <ul ngbNav #nav="ngbNav" class="nav nav-pills nav-justified w-100 custom-nav-tabs">
                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="nav-link fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'iosDevices' }" 
                        (click)="setActiveTab('iosDevices')">
                        IOS Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="iosDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="iosItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of iosItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="iosItems.length === 0" class="text-center w-100">
                                    <p>No iOS devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>

                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'androidDevices' }" 
                        (click)="setActiveTab('androidDevices')">
                        Android Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="androidDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="androidItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of androidItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="androidItems.length === 0" class="text-center w-100">
                                    <p>No Android devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="flex-grow-1 w-100"></div>
        </div>
    </div>
</ng-template>
